(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kaelplay-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kp-hero-carousel')) {
    customElements.define('kp-hero-carousel', class extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-kp-hero-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-kp-hero-dot]'));
        this.viewport = this.querySelector('[data-kp-hero-viewport]');
        this.index = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
        this.interval = Math.max(2000, Number(this.dataset.interval) || 3000);
        this.autoplay = this.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.pointerStart = null;
        this.querySelector('[data-kp-hero-previous]')?.addEventListener('click', () => this.move(-1));
        this.querySelector('[data-kp-hero-next]')?.addEventListener('click', () => this.move(1));
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => {
          this.show(index);
          this.restart();
        }));
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', (event) => {
          if (!this.contains(event.relatedTarget)) this.start();
        });
        this.addEventListener('shopify:block:select', (event) => {
          const slide = event.target.closest('[data-kp-hero-slide]');
          const index = this.slides.indexOf(slide);
          if (index >= 0) this.show(index);
          this.stop();
        });
        this.viewport?.addEventListener('pointerdown', (event) => {
          this.pointerStart = event.clientX;
        });
        this.viewport?.addEventListener('pointerup', (event) => {
          if (this.pointerStart === null) return;
          const distance = event.clientX - this.pointerStart;
          this.pointerStart = null;
          if (Math.abs(distance) > 45) this.move(distance < 0 ? 1 : -1);
        });
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.stop();
          else this.start();
        });
        this.show(this.index);
        this.start();
      }

      disconnectedCallback() {
        this.stop();
      }

      show(index) {
        if (!this.slides.length) return;
        this.index = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, slideIndex) => {
          const active = slideIndex === this.index;
          slide.classList.toggle('is-active', active);
          slide.classList.toggle('is-before', slideIndex < this.index);
          slide.classList.toggle('is-after', slideIndex > this.index);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
          if (active) slide.removeAttribute('tabindex');
          else slide.setAttribute('tabindex', '-1');
        });
        this.dots.forEach((dot, dotIndex) => {
          const active = dotIndex === this.index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });
      }

      move(direction) {
        this.show(this.index + direction);
        this.restart();
      }

      start() {
        if (!this.autoplay || this.slides.length < 2 || this.matches(':hover') || this.matches(':focus-within')) return;
        this.stop();
        this.timer = window.setInterval(() => this.show(this.index + 1), this.interval);
      }

      stop() {
        window.clearInterval(this.timer);
      }

      restart() {
        this.stop();
        this.start();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kaelplay-promo-popup"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('.kp-promo-root:not([data-ready])');
    roots.forEach((root) => {
      root.dataset.ready = 'true';
      const launch = root.querySelector('[data-kp-promo="launch"]');
      const second = root.querySelector('[data-kp-promo="second"]');
      const enabled = root.dataset.enabled === 'true';
      const secondEnabled = root.dataset.secondEnabled === 'true';
      const designMode = root.dataset.designMode === 'true';
      const success = root.querySelector('[data-kp-coupon]') !== null;
      const key = `kaelplay-promo-${root.dataset.sectionId}`;
      const subscribedKey = 'kaelplay-promo-subscribed';
      const inWindow = () => {
        const start = new Date(`${root.dataset.startDate}T00:00:00-05:00`);
        const end = new Date(`${root.dataset.endDate}T23:59:59-05:00`);
        const now = new Date();
        return !Number.isNaN(start.valueOf()) && !Number.isNaN(end.valueOf()) && now >= start && now <= end;
      };
      const openDialog = (dialog) => {
        if (dialog && !dialog.open) dialog.showModal();
      };
      root.querySelectorAll('[data-kp-close]').forEach((button) => {
        button.addEventListener('click', () => {
          const dialog = button.closest('dialog');
          dialog.close();
          sessionStorage.setItem(`${key}-${dialog.dataset.kpPromo}-dismissed`, '1');
        });
      });
      root.querySelectorAll('dialog').forEach((dialog) => {
        dialog.addEventListener('click', (event) => {
          if (event.target === dialog) {
            dialog.close();
            sessionStorage.setItem(`${key}-${dialog.dataset.kpPromo}-dismissed`, '1');
          }
        });
      });
      if (success) {
        localStorage.setItem(subscribedKey, '1');
        openDialog(launch);
        return;
      }
      if (!enabled || (!designMode && !inWindow()) || localStorage.getItem(subscribedKey) === '1') return;
      if (sessionStorage.getItem(`${key}-launch-dismissed`) !== '1') {
        window.setTimeout(() => openDialog(launch), Number(root.dataset.delay || 1) * 1000);
      }
      if (secondEnabled) {
        document.addEventListener('shopify:cart:lines-update', () => {
          if (localStorage.getItem(subscribedKey) === '1') return;
          if (sessionStorage.getItem(`${key}-second-shown`) === '1') return;
          sessionStorage.setItem(`${key}-second-shown`, '1');
          window.setTimeout(() => {
            if (launch.open) launch.close();
            openDialog(second);
          }, 450);
        });
      }
      document.addEventListener('shopify:section:select', (event) => {
        if (event.detail.sectionId === root.dataset.sectionId) openDialog(launch);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
